export const isInternalUser = (username?: string): boolean => {
  if (!username) {
    return false;
  }
  return username?.includes("@finbounce.com");
};
